
const ActivityLogs = ({ logs }) => {
  const columns = [
    {
      title: 'Timestamp',
      dataIndex: 'timestamp',
    },
    {
      title: 'Action Type',
      dataIndex: 'actionType',
    },
    {
      title: 'Action By',
      dataIndex: 'actionBy',
    },
    {
      title: 'Action Details',
      dataIndex: 'actionDetails',
    },
  ];

  const onPageChange = (pageData) => {};
  
  return (
    <div className="activity-logs">
      <h5>Activity Logs</h5>
      <AppTable
        data={logs}
        columns={columns}
        onChange={(...arg) => onPageChange(...arg)}
        total={logs.length}
        reorder={true}
        viewable={false}
        editable={false}
        deletable={false}
      ></AppTable>
    </div>
  );
};

export default ActivityLogs;
